import React from 'react';
import { BrowserRouter as Router, Route,Switch } from 'react-router-dom';
import Home from './components/Home';  // Import the Home component
import About from './components/About';  // Import the About component
import "./App.css";
import CommentList from './components/Coments/CommentList';
import NotFound from './components/utils/NotFound';
import Vidios from './Pages/VideoPage/Vidios';
import VideoList from './Pages/VideoPage/Vidios';

const App = () => {
    return (
        <Router>
             <Switch>
                {/* Route for Home Page */}
                <Route exact path="/" component={Home} />
                {/* Route for About Page */}
                <Route exact path="/about" component={About} />
                <Route exact path="/discussion" component={CommentList}/>
                <Route exact path="/videos" component={VideoList}/>
                <Route exact path="*" component={NotFound}/>
            </Switch>
        </Router>
    );
};

export default App;
